import React from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { ErrorModal } from '../../components/modals/error-modal';
import { messages } from './messages';

const mapStateToProps = (_, props) => {
  const { modalFrameworkMethods, title, message } = props;
  return {
    modalFrameworkMethods,
    title,
    message,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { action, onClick } = props;
  return {
    buttons: [
      {
        children: <FormattedMessage {...messages.cancel} />,
      },
      {
        theme: 'primary',
        children: <FormattedMessage {...messages.tryAgain} />,
        onClick: action
          ? () => {
              dispatch({ ...action, override: true });
            }
          : onClick,
      },
    ],
  };
};

export const GenericErrorRetryContainer = connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
